import * as Actions from '../constant/ActionTypes';

const fetchSelectedBusinessReducers = (data=[], action) => {
    switch(action.type) {
        case Actions.SELECTED_BUSINESS:     
            return action.payload;

        default :
        return data;
    }
}
export default fetchSelectedBusinessReducers;